/**
 * Status strips under the top bar:
 *  - ReconnectBanner — the multiplayer line dropped and the net layer is re-establishing it
 *    (lobbyStore.status goes back to 'connecting' during auto-reconnect);
 *  - CommandNotice — a command the host rejected (fed from net/router `onCommandResult` in
 *    GameScreen via hudStore.flashNotice).
 */
import { useEffect } from 'react';
import { useT } from '../../i18n';
import { getConnection } from '../../net/connection';
import { useLobby } from '../../net/lobby';
import { localizeServerText } from '../../net/serverText';
import { cx } from '../common/controls';
import { Icon } from '../common/Icon';
import hud from './hud.module.css';
import { hudStore, useHud } from './hudStore';

const NOTICE_MS = 3800;

export function ReconnectBanner({ className }: { className?: string }) {
  const t = useT();
  const status = useLobby((l) => l.status);
  if (status !== 'connecting' || getConnection()?.kind !== 'ws') return null;
  return (
    <div className={cx(hud.banner, hud.bannerWarn, className)} role="status">
      <span className={hud.bannerLed} />
      {t('net.reconnecting')}
    </div>
  );
}

export function CommandNotice() {
  const t = useT();
  const notice = useHud((h) => h.notice);
  useEffect(() => {
    if (!notice) return;
    const t = window.setTimeout(() => hudStore.getState().clearNotice(notice.id), NOTICE_MS);
    return () => clearTimeout(t);
  }, [notice]);
  if (!notice) return null;
  return (
    <div key={notice.id} className={cx(hud.banner, hud.bannerBad)} role="alert">
      <Icon name="close" size={13} />
      {t('cmd.rejected', { reason: localizeServerText(notice.text, t) })}
    </div>
  );
}
